(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/overview-hero.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/overview-hero.js');

'use strict';

const {
  withHeroContent
} = svs.components.marketplaceCompetition.overviewHero.hoc;
const OverviewHero = _ref => {
  let {
    overrides
  } = _ref;
  const HeroWithContent = withHeroContent();

  return React.createElement(HeroWithContent, {
    overrides: overrides,
    vertical: "middle"
  });
};
OverviewHero.defaultProps = {
  overrides: {}
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.OverviewHero', OverviewHero);

 })(window);